import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { getDateProduction } from "../../../Base/Services/FechasService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Card from "../../../Base/Components/Card/Card";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarOrdenVenta, EliminarOrdenVentaDet, getDetallesSales, getEncabezadoSales, LiberarOrdenVenta } from "../../../API/Ventas/SalesOrdersRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import SalesOrdersCRUD from "./SalesOrdersCRUD";
import SalesOrderReporte from "./SalesOrderReporte";

const SalesOrdersScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogReporte, setShowDialogReporte] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedEnc, setSelectedEnc] = useState([]);
  const [selectedDet, setSelectedDet] = useState([]);
  const [Languaje, setLanguaje] = useState('es');
  const [hiddenliberar, setHiddenLiberar] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(63));
  

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      return;
    }
    setLoading(true);
    setLanguaje('es')
    const fechas = getDateProduction(dates);

    const encabezadoTempo = await getEncabezadoSales(fechas);
    setListadoEnc(encabezadoTempo);

    const detallesTempo = await getDetallesSales(fechas);
    setListadoDet(detallesTempo);

    setLoading(false);
  };

  const LiberarOrden = async (data) => {
    confirmDialog({
      message: "¿Está seguro que desea Liberar la orden?",
      header: "Liberar",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setLoading(true);
        const fuente = selectedEnc?.length > 0 ? selectedEnc : data;
        const datosEnviar = fuente.map((s) => ({
          ...s,
          IdSalesOrderEnc: s?.IdSalesOrderEnc,
          IdUserEdit: userAuth?.IdUser,
          status: !s.liberado ? 106 : 102
        }));
  
        for (const item of datosEnviar) {
          await LiberarOrdenVenta(item.IdSalesOrderEnc, item.IdUserEdit, !item?.liberado);
        }
        toastShow(toast, "success", "Editado", "Estado cambiado correctamente");
        setTimeout(() => {
          setLoading(false);
          setSelectedEnc([]);
          getInfo();
        }, 500);
      },
      reject: () => {},
    });
  };

  const EliminarOrden = async () => {
    if(activeIndex === 0){
      let dataLiberdada = selectedEnc?.find(i=> i?.IdStatus === 106)
      let datos = selectedEnc?.filter(i => i?.IdStatus !== 106)
      if(dataLiberdada){
        toastShow(toast, 'warn', 'Advertencia','Algunas ordenes seleccionadas no se pueden eliminar, ya estan Liberadas.')
      }
      if(datos?.length > 0){
        confirmDialog({
          message: "¿Está seguro que desea Eliminar la orden de venta?",
          header: "Eliminar Orden",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            setLoading(true)
            const datosEnviar = datos.map((s) => ({
              ...s,
              IdSalesOrderEnc: s?.IdSalesOrderEnc,
              IdUserEdit: userAuth?.IdUser,
              status: 104
            }));
            for (const item of datosEnviar) {
              await EliminarOrdenVenta(item.IdSalesOrderEnc, item.IdUserEdit, item?.status);
            }
            toastShow(toast, "success", "Eliminada", "Orden de venta eliminada correctamente");
            setLoading(false);
            setSelectedEnc([]);
            getInfo();
          },
          reject: () => {},
        });
      }
    }else if(activeIndex === 1){
      let dataLiberdada = selectedDet?.find(i=> i?.IdStatus === 106)
      let datos = selectedDet?.filter(i => i?.IdStatus !== 106)
      if(dataLiberdada){
        toastShow(toast, 'warn', 'Advertencia','Algunos detalles seleccionadas no se pueden eliminar, ya estan Liberados.')
      }
      if(datos?.length > 0){
        confirmDialog({
          message: "¿Está seguro que desea eliminar detalles?",
          header: "Eliminar Detalles",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            setLoading(true)
            const datosEnviar = datos.map((s) => ({
              ...s,
              IdSalesOrderDet: s?.IdSalesOrderDet,
              IdUserEdit: userAuth?.IdUser,
              status: 104
            }));
            for (const item of datosEnviar) {
              await EliminarOrdenVentaDet(item.IdSalesOrderDet, item.IdUserEdit, item?.status);
            }
            toastShow(toast, "success", "Eliminado", "Detalles eliminados correctamente");
            setLoading(false);
            setSelectedEnc([]);
            getInfo();
          },
          reject: () => {},
        });       
      }
    }
  }

  const columns = [
    {
      field: "IdSalesOrderEnc",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      header: "Fecaha Creación",
      headerEn: "Date Create",
      Format: "Date",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "NoOrden",
      headerEn: "No. Order",
      header: "No. Orden",
      frozen: 1,
      className: "small",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      // cellEditor: changeEstado,
      // editable: true,
    },
    {
      field: "CustomerName",
      header: "Cliente",
      headerEn: "Customer",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "CompanyName",
      header: "Buyer",
      headerEn: "Buyer",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "CustomerOrder",
      header: "Orden Cliente",
      headerEn: "Customer Order",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "TerminoEnvio",
      header: "Término Envío",
      headerEn: "Shipping Term",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "TerminoVenta",
      header: "Término Venta",
      headerEn: "Sales Term",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      flex: 1,
      width: 600,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "liberado",
      header: "Liberar",
      headerEn: 'Release',
      width: 70,
      frozen: true,
      alignFrozen: "right",
      Format: "Template",
      body: (data) =>
        data.IdSalesOrderEnc ? (
          <div
            onClick={() => {}}
            onDoubleClick={(e) => {}}
            className="d-flex flex-row"
            style={{ justifyContent: "center", marginTop: 2 }}
          >
            <Checkbox
              checked={data.liberado}
              disabled={!hiddenliberar}
              onClick={() => {
                LiberarOrden([data]);
              }}
            />
          </div>
        ) : null,
    },
    {
      field: "IdSalesOrderEnc",
      header: "Formato",
      headerEn: "Format",
      Format: "SplitButton",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      className: 'Xsmall',
      Botones: [
        {
          icon: "pi pi-print",
          tooltip: "Formato",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdSalesOrderEnc > 0) {
              setShowDialogReporte(true);
              setSelectedEnc([rowData]);
            }
          },
          items: [
            {
              label: "Ingles",
              onClick: (rowData) => {
                if (rowData?.IdSalesOrderEnc > 0) {
                  setShowDialogReporte(true);
                  setSelectedEnc([rowData]);
                  setLanguaje('en')
                }
              },
            },
            {
              label: "Español",
              onClick: (rowData) => {
                if (rowData?.IdSalesOrderEnc > 0) {
                  setShowDialogReporte(true);
                  setSelectedEnc([rowData]);
                }
              },
            },
          ]
        },
      ],
    },
    {
      field: "IdSalesOrderEnc",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdSalesOrderEnc > 0) {
              setShowDialog(true);
              setSelectedEnc([rowData]);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    loading: loading,
    selected: selectedEnc,
    setSelected: setSelectedEnc,
    showModal: () => {},
  };

  const columnsDet = [
    {
      field: "IdSalesOrderDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "DateCreateEnc",
      header: "Fecaha Creación",
      headerEn: "Date Create",
      Format: "Date",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "NoOrden",
      headerEn: "No. Order",
      header: "No. Orden",
      frozen: 1,
      className: "small",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
            onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
      // cellEditor: changeEstado,
      // editable: true,
    },
    {
      field: "Yarn",
      header: "Hilo",
      headerEn: "Yarn",
      className: "XXXXlarge",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "ExportDate",
      header: "Fecha de Exportancion",
      headerEn: "Export Date",
      className: "medium",
      Format: "DateTime",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "XXlarge",
      flex: 1,
      minWidth: 200,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdSalesOrderDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "Quantity",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "Kgs",
      header: "Kgs",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "Lbs",
      header: "Lbs",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    // TOTALES
    {
      field: "TasaCambio",
      header: "Tasa Cambio",
      className: "Xsmall",
      Format: "Currency",
    },
    {
      field: "PrecioL",
      header: "Precio L",
      headerEn: "Price L",
      className: "Xsmall",
      Format: "Currency",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "PrecioD",
      header: "Precio $",
      headerEn: "Price $",
      className: "Xsmall",
      Format: "Currency",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "SubTotalL",
      header: "SubTotal L",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "SubTotalD",
      header: "SubTotal $",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },

    {
      field: "IdSalesOrderDet",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdSalesOrderDet > 0) {
              setShowDialog(true);
              setSelectedEnc([rowData]);
            }
          },
        },
      ],
    },
  ];

  const tableDet = {
    Columns: columnsDet,
    Data: listadoDet,
    loading: loading,
    selected: selectedDet,
    setSelected: setSelectedDet,
    showModal: () => {},
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "OrdenesVenta", config.language));
  }, []);

  useEffect(() => {
    setSelectedDet([]);
    setSelectedEnc([]);
  }, [activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h2>{getLabel(baseLang, "OrdenesVenta", config.language)}</h2>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />

            <Button
              icon="pi pi-times"
              tooltip={activeIndex === 0 ? "Eliminar Orden" : "Eliminar Detalles"}
              className="p-button-danger"
              disabled={activeIndex === 0 ? selectedEnc?.length === 0 : selectedDet?.length === 0}
              onClick={(e) => EliminarOrden()}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={getLabel(baseLang, "listadoTab", config.language)}>
                <div style={{ height: "80vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "requisasTab", config.language)}>
                <div style={{ height: "80vh" }}>
                  <AgGrid table={tableDet} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      {showDialog && (
        <SalesOrdersCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          selectedEnc={selectedEnc}
          setSelectedEnc={setSelectedEnc}
          getInfo={getInfo}
        />
      )}

      {showDialogReporte && (
        <SalesOrderReporte
          showDialogReporte={showDialogReporte}
          setShowDialogReporte={setShowDialogReporte}
          selectedEnc={selectedEnc}
          getInfo={getInfo}
          Language={Languaje}
        />
      )}
    </div>
  );
};

export default SalesOrdersScreen;
